/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/boxList.config.json";
import axios from "axios";
import { LoggerModule } from "@vlinder-web/logger-module-react";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_BOX_LIST } from "../graphql";
import { VApplication } from "../../../application";
import moment from "moment-timezone";
import { capitalCase } from "change-case";
import { StorageModule } from "@vlinder-web/storage-module-react";

const log: any = LoggerModule?.getInstance();
const storageService = StorageModule.getInstance();

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IBoxListMethods extends IPluginMethodMap {
  getBoxList(args: any): Promise<any>;
}

export class BoxListService implements IAgentPlugin {
  readonly methods: IBoxListMethods;

  constructor() {
    this.methods = {
      getBoxList: this.getBoxList.bind(this),
    };
  }

  async getBoxList(args: any) {
    log.blue(`getBoxList server component:`, args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      // return {...config}
      if (client) {
        const res = await client.query({
          query: GET_BOX_LIST,
          variables: {
            options: {
              limit: args?.size ?? 10,
              skip: args?.offset ?? 0,
            },
            filters: {
              ...args?.criteria,
              box___band__in:
                storageService.get("bandConfig", "local")?.band?.appCardId ??
                null,
            },
          },
          fetchPolicy: "network-only",
        });
        if (res?.data) {
          let _totalPages = res?.data?.getUsersWithBoxes?.count
            ? parseInt(res?.data?.getUsersWithBoxes?.count) / 10
            : 1;
          let _currentPage =
            res?.data?.getUsersWithBoxes?.skip /
              res?.data?.getUsersWithBoxes?.limit +
            1;
          return {
            ...config,
            band: {
              name:
                storageService.get("bandConfig", "local")?.band?.appCardTitle ??
                null,
              id:
                storageService.get("bandConfig", "local")?.band?.appCardId ??
                null,
            },
            isEmpty: res?.data?.getUsersWithBoxes?.content?.length <= 0,
            ultUsers: this._getBoxData(res?.data?.getUsersWithBoxes?.content),
            activePage: _currentPage,
            pageSize: res?.data?.getUsersWithBoxes?.limit,
            totalCount: res?.data?.getUsersWithBoxes?.count,
            totalPages: _totalPages,
          };
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      return {
        isEmpty: true,
      };
    }
  }

  private _getBoxData = (data: any) => {
    let _res: any[] = [];
    data &&
      Array.isArray(data) &&
      data.length > 0 &&
      data.map((item: any, index: number) => {
        let _box = item?._box;
        console.log(`_box`, _box?.isVIP);
        _res.push({
          id: _box?.id,
          // status: _box?.status,
          status: this.getFormattedStatus(
            _box?.user?.accountStatus,
            _box?.user?.suspended
          ),
          name: `${_box?.user?.firstName} ${_box?.user?.lastName}`,
          email: _box?.user?.email,
          image: _box?.user?.image,
          verified: _box?.user?.emailVerified,
          //role: this._getRoles(_box?.role, roles),
          mascID: _box?.masqID,
          costumeID: _box?.costumeID,
          gender: _box?.gender,
          isVIP: _box?.isVIP ? true : false,
          createdAt: _box?.createdAt
            ? this.formatCreatedDate(_box?.createdAt)
            : "",
          paymentStatus: _box?.paymentStatus,
          contentStatus: _box?.contentStatus,
        });
      });
    console.log(`_getSehlfData : `, _res);
    return _res;
  };

  private formatCreatedDate(date: Date) {
    const metaData = storageService.get("bandConfig", "local")?.metaData;
    console.log(`metaData`, metaData);
    if (date && metaData) {
      let _date = `${moment.tz(date, metaData?.tmz).format("LLL")} ${
        metaData?.abbrevation
      }`;
      console.log(`_date`, _date);
      return _date;
    }
  }

  private getFormattedStatus(status: string, suspended: boolean) {
    if (suspended) {
      return "suspended";
    } else {
      switch (status) {
        case "USER_ADDED":
          return "created";
        case "INVITED":
          return "invited";
        case "EMAIL_VERIFIED":
          return "verified";
        case "ACC_CREATED":
          return "active";
        case "WALLET_REGISTERED":
          return "active";
        case "SUSPENDED":
          return "suspended";
        default:
          return "-";
      }
    }
  }
}
